import React from 'react'
import { BaseDatePicker } from '../../../components/shared'
import { func, any } from 'prop-types'
import Dater from '../../../services/DateFormat'

export default function YearFilter({ onChange, value, onClear }) {
  const MinDate = '2023-01-01'
  const MaxDate = parseInt(Dater().formatar(new Date(), 'yyyy')) + '-12-31'
  return (
    <BaseDatePicker
      minDate={MinDate}
      maxDate={MaxDate}
      value={value}
      onChange={onChange}
      label="Ano"
      inputFormat="YYYY"
      openTo="year"
      views={['year']}
      onClear={onClear}
      clearable={true}
    />
  )
}

YearFilter.propTypes = {
  onChange: func,
  value: any,
  onClear: func
}
